module.exports = __webpack_public_path__ + "static/program-uni677242-471133caf6fa3beb6cc2ca73cc62f696.png";